module.exports = __webpack_public_path__ + "img/img_03@2x.49d4f082.png";